import type { ComponentType, SVGProps } from "react";
import { TaskCancelledIcon, TaskDoneIcon } from "@icons/taskStatuses";
import type { ClientsWorkOverviewWorkRow } from "../clientsWorkOverviewViewConfig";
import {
    CANCELED_STAGE_GROUP_ID,
    DONE_STAGE_GROUP_ID,
    getWorkFinishedState,
    WORK_FINISHED_STATE_TITLES,
    type WorkFinishedState,
} from "../workStageGroups";

interface WorkFinishedStatus {
    label: string;
    Icon: ComponentType<SVGProps<SVGSVGElement>>;
}

const STATUS_BY_STATE: Record<WorkFinishedState, WorkFinishedStatus> = {
    canceled: {
        label: WORK_FINISHED_STATE_TITLES.canceled,
        Icon: TaskCancelledIcon,
    },
    done: { label: WORK_FINISHED_STATE_TITLES.done, Icon: TaskDoneIcon },
};

const STATUS_BY_COLUMN_ID = new Map([
    [DONE_STAGE_GROUP_ID, STATUS_BY_STATE.done],
    [CANCELED_STAGE_GROUP_ID, STATUS_BY_STATE.canceled],
]);

/** Done or Canceled for finished work, as List's Stage cell reads; open work has none. */
export const getWorkFinishedStatus = (
    row: Pick<ClientsWorkOverviewWorkRow, "cancelledAt" | "isFinished">,
): WorkFinishedStatus | null => {
    const finishedState = getWorkFinishedState(row);
    return finishedState ? STATUS_BY_STATE[finishedState] : null;
};

/** The Done and Canceled columns' header icons; stage columns have none, as in List. */
export const getWorkBoardColumnIcon = (columnId: string) => {
    const status = STATUS_BY_COLUMN_ID.get(columnId);
    return status ? <status.Icon aria-hidden /> : null;
};
